import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { CertificateHelperService } from './certificate.helper.service';

@Injectable({
  providedIn: 'root',
})
export class CertificateService {
  paragraphColumn = {
    margin: [0, 0, 0, 0],
    fontSize: 11,
    border: [false, false, false, false],
  };
  hLineBorder = {
    hLineWidth: () => {
      return 1;
    },
    hLineColor: () => {
      return 'gray';
    },
    hLineStyle: (i: number) => {
      return { dash: { length: 2, space: 2 } };
    },
  };
  hLineBorderAlt = {
    hLineWidth: () => {
      return 1;
    },
    hLineColor: () => {
      return 'gray';
    },
    hLineStyle: (i: number, node: any) => {
      return { dash: { length: 5, space: 2 } };
      return null;
    },
  };
  constructor(
    private datePipe: DatePipe,
    private certificateHelper: CertificateHelperService
  ) {}

  private async appLogo() {
    const image = await fetch('assets/images/platStet.png');
    return image.url;
  }

  private async appFavicon() {
    const image = await fetch('assets/images/platStet.png');
    return image.url;
  }

  private async appStamp() {
    const image = await fetch('assets/images/stamp.png');
    return image.url;
  }

  private async receiptLogoHeader(): Promise<SafeResourceUrl> {
    const row: any[] = [
      {
        image: 'certLogo',
        width: 60,
        alignment: 'center',
        margin: [0, 0, 0, 2],
        verticalAlignment: 'middle',
        border: [false, false, false, false],
      },
    ];
    return [row];
  }
}
